import * as yup from 'yup';

const userSettingStringArraySchema = yup.array().of(yup.string());

export const ValidateUserSettingArrayOfStrings = (value) => {
  userSettingStringArraySchema.validateSync(value);
};
